import { Box, Button, Card, Dialog, DialogContent, DialogTitle, IconButton, TextField, Tooltip, Typography, Table, TableHead, TableBody, TableRow, TableCell } from '@mui/material'
import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { hours } from '../hours'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CloseIcon from '@mui/icons-material/Close';
import { useDispatch } from 'react-redux';
import { deleteEventPair } from 'src/redux/actions/Scheduler';
import { useSelector } from 'react-redux';
import AddIcon from '@mui/icons-material/Add';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { getEventPairInterval } from 'src/utils/getEventPairInterval';

const EventsList = ({open, onClose, schedulerId, openAddEventDialog, openEvent}) => {
    const { t } = useTranslation()
    const dispatch = useDispatch()
    const {schedulers} = useSelector((state) => state.Scheduler)

    const daysWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']

    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    const groupSchedulerEvents = useMemo(() => {
        const pairs = []
        const sch = schedulers.find(sch => sch._id == schedulerId)
        if(sch) {
            sch.events.filter(e => e.type == 'start').forEach(e => {
                pairs.push({
                    start: e
                })
            })
    
            sch.events.filter(e => e.type == 'stop').forEach(e => {
                const index = pairs.findIndex(ei => ei.start.pair == e.pair)
                pairs[index].stop = e
            })
            console.log(pairs)
            return pairs
        }else {
            return pairs
        }
    }, [schedulerId])

    console.log(groupSchedulerEvents)

    const ParsedTimestamp = ({eventStart, eventStop}) => {
        const timestamp = eventStart.when
        if(timestamp.includes('WWW') && timestamp.includes('MMM') && timestamp.includes('DD') && timestamp.includes('RRRR') && !timestamp.includes('**:**:**')) {
            return {
                interval: t("views.scheduler.everyDay"),
                startTime: eventStart.when.split(' ')[4].slice(0, 5),
                endTime: eventStop.when.split(' ')[4].slice(0, 5),
                startDate: null,
                endDate: null
            }
        }
        if(!timestamp.includes('WWW') && timestamp.includes('MMM') && timestamp.includes('DD') && timestamp.includes('RRRR') && !timestamp.includes('**:**:**')) {
            return {
                interval: t("views.scheduler.everyWeek"),
                startTime: timestamp.split(' ')[4].slice(0, 5),
                endTime: eventStop.when.split(' ')[4].slice(0, 5),
                startDate: daysWeek.find(dw => dw.includes(timestamp.split(' ')[0])),
                endDate: daysWeek.find(dw => dw.includes(eventStop.when.split(' ')[0]))
            }
        }
        if(timestamp.includes('WWW') && timestamp.includes('MMM') && !timestamp.includes('DD') && timestamp.includes('RRRR') && !timestamp.includes('**:**:**')) {
            return {
                interval: t("views.scheduler.everyMonth"),
                startTime: timestamp.split(' ')[4].slice(0, 5),
                endTime: eventStop.when.split(' ')[4].slice(0, 5),
                startDate: `${timestamp.split(' ')[2]}${timestamp.split(' ')[2] == '01' ? 'st' : timestamp.split(' ')[2] == '02' ? 'nd' : timestamp.split(' ')[2] == '03' ? 'rd' : 'th'}`,
                endDate: `${eventStop.when.split(' ')[2]}${eventStop.when.split(' ')[2] == '01' ? 'st' : eventStop.when.split(' ')[2] == '02' ? 'nd' : eventStop.when.split(' ')[2] == '03' ? 'rd' : 'th'}`
            }
        }
        if(timestamp.includes('WWW') && !timestamp.includes('MMM') && !timestamp.includes('DD') && timestamp.includes('RRRR') && !timestamp.includes('**:**:**')){
            return {
                interval: t("views.scheduler.everyYear"),
                startTime: timestamp.split(' ')[4].slice(0, 5),
                endTime: eventStop.when.split(' ')[4].slice(0, 5),
                startDate: `${months.find(m => m.includes(timestamp.split(' ')[1]))} ${timestamp.split(' ')[2]}${timestamp.split(' ')[2] == '01' ? 'st' : timestamp.split(' ')[2] == '02' ? 'nd' : timestamp.split(' ')[2] == '03' ? 'rd' : 'th'}`,
                endDate: `${months.find(m => m.includes(eventStop.when.split(' ')[1]))} ${eventStop.when.split(' ')[2]}${eventStop.when.split(' ')[2] == '01' ? 'st' : eventStop.when.split(' ')[2] == '02' ? 'nd' : eventStop.when.split(' ')[2] == '03' ? 'rd' : 'th'}`
            }
        }
        if (timestamp.includes('WWW') && !timestamp.includes('MMM') && !timestamp.includes('DD') && !timestamp.includes('RRRR') && !timestamp.includes('**:**:**')){
            return {
                interval: t("views.scheduler.once"),
                startTime: timestamp.split(' ')[4].slice(0, 5),
                endTime: eventStop.when.split(' ')[4].slice(0, 5),
                startDate: `${months.find(m => m.includes(timestamp.split(' ')[1]))} ${timestamp.split(' ')[2]}${timestamp.split(' ')[2] == '01' ? 'st' : timestamp.split(' ')[2] == '02' ? 'nd' : timestamp.split(' ')[2] == '03' ? 'rd' : 'th'} ${timestamp.split(' ')[3]}`,
                endDate: `${months.find(m => m.includes(eventStop.when.split(' ')[1]))} ${eventStop.when.split(' ')[2]}${eventStop.when.split(' ')[2] == '01' ? 'st' : eventStop.when.split(' ')[2] == '02' ? 'nd' : eventStop.when.split(' ')[2] == '03' ? 'rd' : 'th'} ${eventStop.when.split(' ')[3]}`
            }
        }
        return {
            interval: 'Unknown',
            startTime: '',
            endTime: '',
            startDate: null,
            endDate: null
        }
    }

    return (
        <Dialog fullWidth maxWidth="md" open={open} onClose={onClose}>
            <Box sx={{
                display: 'flex',
                justifyContent: "space-between",
                alignItems: "center",
                px: 2
            }}>
                <div style={{width: "40px"}}></div>
                <DialogTitle mt={2} textAlign="center">{t("views.scheduler.eventDetails")}</DialogTitle>
                <IconButton onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </Box>
            <DialogContent>
                {groupSchedulerEvents.length > 0 ? (
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>{t("views.scheduler.interval")}</TableCell>
                                <TableCell align="center">{t("views.scheduler.startDateTime")}</TableCell>
                                <TableCell align="center">{t("views.scheduler.endDateTime")}</TableCell>
                                <TableCell>{t("views.scheduler.object")}</TableCell>
                                <TableCell align="center">{t("views.scheduler.actions")}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {groupSchedulerEvents.map(e => {
                                const parsed = ParsedTimestamp({eventStart: e.start, eventStop: e.stop})
                                return (
                                    <TableRow key={e.start._id} hover>
                                        <TableCell>{parsed.interval}</TableCell>
                                        <TableCell align="center">
                                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                                                {parsed.startDate && <Typography variant="body2">{parsed.startDate}</Typography>}
                                                <Typography variant="h6">{parsed.startTime}</Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell align="center">
                                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                                                {parsed.endDate && <Typography variant="body2">{parsed.endDate}</Typography>}
                                                <Typography variant="h6">{parsed.endTime}</Typography>
                                            </Box>
                                        </TableCell>
                                        <TableCell>
                                            <Tooltip title={e.start?.playlist?.playlistName?.length > 30 ? e.start?.playlist?.playlistName : ''}>
                                                <Typography variant="body1">
                                                    {e.start?.playlist?.playlistName?.length > 30 
                                                        ? `${e.start?.playlist?.playlistName?.slice(0, 30)}...` 
                                                        : e.start?.playlist?.playlistName}
                                                </Typography>
                                            </Tooltip>
                                        </TableCell>
                                        <TableCell align="center">
                                            <IconButton 
                                                onClick={() => {
                                                    openEvent(e.start.pair)
                                                    onClose()
                                                }} 
                                                size="small"
                                            >
                                                <MoreHorizIcon />
                                            </IconButton>
                                        </TableCell>
                                    </TableRow>
                                )
                            })}
                        </TableBody>
                    </Table>
                ) : (
                    <Box sx={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "20px",
                        py: 4
                    }}>
                        <Typography variant='h5' color="text.secondary">{t("views.scheduler.noEventsInScheduler")}</Typography>
                        <Button onClick={() => {
                            onClose()
                            openAddEventDialog()
                        }} endIcon={<AddIcon/>}>{t("views.scheduler.addEvent")}</Button>
                    </Box>
                )}
            </DialogContent>
        </Dialog>
    )
}

export default EventsList
